<template>
	<div class="stat-page">
		<!-- 第一行：产品类统计 单卡片 -->
		<el-row :gutter="20">
			<el-col :span="12">
				<el-card shadow="hover" class="stat-card">
<!--					<div slot="header" class="card-header">产品类统计</div>-->
					<el-table :data="productTotal" border size="mini">
						<el-table-column label="产品类统计" prop="label" />
						<el-table-column label="数量" prop="count" />
					</el-table>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card shadow="hover" class="stat-card">
<!--					<div slot="header" class="card-header">用户范围</div>-->
					<el-table :data="userDist" border size="mini">
						<el-table-column label="用户范围" prop="name" />
						<el-table-column label="指标" prop="count" />
						<el-table-column label="比例" prop="ratio" />
					</el-table>
				</el-card>
			</el-col>
		</el-row>
		
		<!-- 第二行：学习进度Tab卡片 + TOP榜单Tab卡片 -->
		<el-row :gutter="20" style="margin-top:20px">
			<el-col :span="12">
				<el-card shadow="hover" class="stat-card">
					<div  class="card-header">
						<el-tabs v-model="studyTab" size="mini" @tab-click="changeStudyTab">
							<el-tab-pane label="看视频个数" name="1"></el-tab-pane>
							<el-tab-pane label="看视频时长" name="2"></el-tab-pane>
							<el-tab-pane label="答对题数" name="3"></el-tab-pane>
						</el-tabs>
					</div>
					<el-table :data="studyRate" border size="mini">
						<el-table-column label="学习进度" prop="label" />
						<el-table-column label="人数" prop="num" />
						<el-table-column label="比例" prop="percent" >
							<template slot-scope="scope">
								{{ scope.row.percent }}%
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card shadow="hover" class="stat-card">
					<div  class="card-header">
						<el-tabs v-model="rankTab" size="mini" @tab-click="changeRankTab">
							<el-tab-pane label="点播最多" name="2"></el-tab-pane>
							<el-tab-pane label="收藏最多" name="1"></el-tab-pane>
							<el-tab-pane label="转发最多" name="3"></el-tab-pane>
						</el-tabs>
					</div>
					<el-table :data="top10List" border size="mini">
						<el-table-column label="名次" prop="rank" width="" />
						<el-table-column label="产品名称" prop="productName" />
						<el-table-column label="指标" prop="count" />
					</el-table>
				</el-card>
			</el-col>
		</el-row>
		
		<!-- 第三行：时间维度统计 + 月度统计 -->
		<el-row :gutter="20" style="margin-top:20px">
			<el-col :span="24">
				<el-card shadow="hover" class="stat-card">
					<div  class="card-header">
						<el-radio-group v-model="timeTab" size="mini" @change="fetchTimeStat">
							<el-radio-button label="7">最近7天</el-radio-button>
							<el-radio-button label="30">最近30天</el-radio-button>
							<el-radio-button label="365">最近一年</el-radio-button>
						</el-radio-group>
<!--						<span style="margin-left:10px">学习类统计</span>-->
					</div>
					<el-table :data="timeStat" border size="mini">
<!--						<el-table-column label="月份" prop="month" width="160" ></el-table-column>-->
						<el-table-column label="总观看时长" prop="totalWatchTime" ></el-table-column>
						<el-table-column label="平均观看时长" prop="avgWatchTime" ></el-table-column>
						<el-table-column label="总观看视频数量" prop="totalWatchVideoNum" ></el-table-column>
						<el-table-column label="平均观看数量" prop="avgWatchVideoNum" ></el-table-column>
						<el-table-column label="总答对题数" prop="totalAnswerNum" ></el-table-column>
						<el-table-column label="平均答对题数" prop="avgAnswerNum" ></el-table-column>
						<el-table-column label="答题正确率" prop="rightAnswerRate" ></el-table-column>
						<el-table-column label="总下载资料" prop="totalDownloadNum" ></el-table-column>
						<el-table-column label="平均下载资料" prop="avgDownloadNum" ></el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="margin-top:20px">
			<el-col :span="24">
				<el-card shadow="hover" class="stat-card">
					<div  class="card-header">
						<span>每月学习情况</span>
						&nbsp;&nbsp;
<!--						<el-select v-model="selectYear" size="mini" style="margin-left:10px" @change="fetchMonthStat">-->
<!--							<el-option label="2026年" value="2026" />-->
<!--							<el-option label="2025年" value="2025" />-->
<!--						</el-select>-->
						<el-date-picker
								v-model="selectYear"
								@change="fetchMonthStat"
								type="year"
								value-format="yyyy"
								placeholder="选择年"
								:picker-options="pickerOptions"
						></el-date-picker>
<!--						<span style="margin-left:10px">学习类统计</span>-->
					</div>
					<el-table :data="monthStat" border size="mini">
						<el-table-column label="月份" prop="month" width="160" ></el-table-column>
						<el-table-column label="总观看时长" prop="totalWatchTime" ></el-table-column>
						<el-table-column label="平均观看时长" prop="avgWatchTime" ></el-table-column>
						<el-table-column label="总观看视频数量" prop="totalWatchVideoNum" ></el-table-column>
						<el-table-column label="平均观看数量" prop="avgWatchVideoNum" ></el-table-column>
						<el-table-column label="总答对题数" prop="totalAnswerNum" ></el-table-column>
						<el-table-column label="平均答对题数" prop="avgAnswerNum" ></el-table-column>
						<el-table-column label="答题正确率" prop="rightAnswerRate" ></el-table-column>
						<el-table-column label="总下载资料" prop="totalDownloadNum" ></el-table-column>
						<el-table-column label="平均下载资料" prop="avgDownloadNum" ></el-table-column>
						
					</el-table>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import axios from 'axios'
import {
	// getHomeProductCount,
	getRegionalOrderCount,
	getOrderProductPromotionProductTopTen,
	getOrderProductPromotionStudyProgress,
	getOrderProductPromotionUserGenderStatistics,
	getOrderProductPromotionUserWatchStats,
	getOrderProductPromotionUserWatchStatsByYear
} from "../../../api/api";
export default {
	name: 'DataStatistics',
	data() {
		return {
			// 学习进度头部tab
			studyTab: '1',
			// 榜单头部tab
			rankTab: '2',
			// 时间筛选
			timeTab: '30',
			// 年份筛选
			selectYear: '2026',
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			
			},
			productTotal: [],
			userDist: [],
			studyRate: [],
			timeStat: [],
			top10List: [],
			monthStat: [],
			projectId: undefined,
			progressRes:undefined,
		}
	},
	methods: {
		// 基础静态数据
		async fetchAllBaseData() {
			await this.fetchProductTotal()
			await this.fetchTimeStat()
			await this.fetchMonthStat()
			await this.fetchAreaOrderUserStat()
			await this.fetchOrderTop10Stat()
			await this.fetchStudyRate()
		},
		// 切换学习进度tab
		changeStudyTab() {
			
			this.fetchStudyRate()
		},
		// 切换榜单tab
		changeRankTab() {
			console.log(this.rankTab,'hhhhhhh')
			this.fetchOrderTop10Stat()
		},
		// 获取产品类统计
		async fetchProductTotal() {
			let params = {
				orderProductPromotionId: this.projectId,
			}
			getRegionalOrderCount(params).then(res=>{
				if (res.data.success) {
					const d = res.data?.response
					console.log('res.data',res.data)
					this.productTotal = [
						{
							label: '产品总数',
							count: d?.productCount,
						},
						{
							label: '单品数量',
							count: d?.productOneCount
						},
						{
							label: '合集数量',
							count: d?.productCompilationsCount,
						},
						{
							label: '相关资料数量',
							count: d?.productDataCount,
						}
					];
				} else {
					this.$message.error(res.data.message);
				}
				
			})
		},
		// 获取区域订单用户统计
		async fetchAreaOrderUserStat() {
			let params = {
				orderProductPromotionId : this.projectId,
			}
			const res = await getOrderProductPromotionUserGenderStatistics(params)
			if (res.data.success){
				this.userDist = res.data.response
				
			}else {
				this.$message.error(res.data.message)
			}
		},
		// 获取学习进度分布
		async fetchStudyRate() {
			let params = {
				orderProductPromotionId : this.projectId,
				type : this.studyTab
			}
			const res = await getOrderProductPromotionStudyProgress(params)
			if (res.data.success){
				this.progressRes = res.data.response
				this.formatTableData()
			}else {
				this.$message.error(res.data.message)
			}
		},
		// 格式化数据方法
		formatTableData() {
			const data = this.progressRes
			this.studyRate = [
				{
					label: '少于25%',
					num: data.studyLess25||0,
					percent: data.studyLess25Percent||0,
				},
				{
					label: '25%——50%',
					num: data.study25To50||0,
					percent: data.study25To50Percent||0
				},
				{
					label: '51%——75%',
					num: data.study50To75||0,
					percent: data.study50To75Percent||0
				},
				{
					label: '75%——99%',
					num: data.study75To99||0,
					percent: data.study75To99Percent||0
				},
				{
					label: '100%',
					num: data.study100||0,
					percent: data.study100Percent||0
				}
			]
		},
		// 获取订单Top10统计
		async fetchOrderTop10Stat() {
			let params = {
				orderProductPromotionId : this.projectId,
				type : this.rankTab
			}
			const res = await getOrderProductPromotionProductTopTen(params)
			if (res.data.success){
				this.top10List = res.data.response
				
			}else {
				this.$message.error(res.data.message)
			}
		},
		// 获取7/30/一年统计
		async fetchTimeStat() {
			let params = {
				orderProductPromotionId : this.projectId,
				timeRange : this.timeTab
			}
			const res = await getOrderProductPromotionUserWatchStats(params)
			if (res.data.success){
				this.timeStat = [res.data.response]
				
			}else {
				this.$message.error(res.data.message)
			}
		},
		// 获取月度年度数据
		async fetchMonthStat() {
			let params = {
				orderProductPromotionId : this.projectId,
				year : this.selectYear
			}
			const res = await getOrderProductPromotionUserWatchStatsByYear(params)
			if (res.data.success){
				this.monthStat = res.data.response
			}else {
				this.$message.error(res.data.message)
			}
		},
	},
	created() {
		this.projectId = this.$route.query.id
	},
	mounted() {
		this.fetchAllBaseData()
	},
	
}
</script>

<style scoped>
.stat-page {
	padding:20px;
	background: #f5f7fa;
	min-height: 100vh;
}
.stat-card {

}
.card-header {
	display: flex;
	align-items: center;
	padding: 10px;
}
.el-table {
	background: #fff;
}
/* 缩小tab间距，适配卡片头部 */
.el-tabs__header {
	margin-bottom: 0 !important;
}
.el-tabs__nav-wrap {
	padding: 0;
}
</style>